<template>
  <vs-table
    :multiple="multiple"
    no-data-text="No tienes destinos"
    v-model="destinationsSelected"
    :data="destinations"
    class="table"
  >
    <template slot="thead">
      <vs-th >Destino</vs-th>
      <vs-th>Salida</vs-th>
      <vs-th>Llegada</vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :data="tr" v-for="(tr, indextr) in data" :key="indextr">
        <vs-td :data="data[indextr].destination">
          {{tr.destination}}
        </vs-td>
        <vs-td :data="data[indextr]">
          {{tr.departureTime && `Hora: ${tr.departureTime}`}} <br />
          {{tr.mileageOutput && `Kilometraje: ${tr.mileageOutput}`}}
        </vs-td>
        <vs-td :data="data[indextr]">
          {{tr.arrivalTime && `Hora: ${tr.arrivalTime}`}} <br />
          {{tr.mileageArrival && `Kilometraje: ${tr.mileageArrival}`}}
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
export default {
  data() {
    return {
      destinationsSelected: this.value || []
    };
  },
  watch: {
    destinationsSelected() {
      this.$emit('input', this.destinationsSelected);
    },
    value(newValue) {
      this.destinationsSelected = newValue;
    }
  },
  props: {
    destinations: {
      type: Array,
      required: false,
      default: () => []
    },
    value: {
      type: Array,
      required: true,
      default: () => []
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true
    }
  }
};
</script>
